import { assign } from 'xstate';

import { type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const clearGroupOrderReorderRequest: ReorderMachineAction = assign(() => ({
  groupOrderReorderRequest: undefined,
}));
